import React, { useState } from "react";
import bannersideimage from "../../assets/referral/bannersideimage.svg";
import bannerbottom from "../../assets/referral/bannerbottom.svg";
import { useSelector } from "react-redux";
import SocialMediaButtons from "../../components/SosialShare";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSnackbar } from "react-simple-snackbar";

const Referral = () => {

    const refData = useSelector((state) => state.UserReducer.learnerRefferalData);
    const [openSnackbar, closeSnackbar] = useSnackbar();
    const [copied, setCopied] = useState(false);


  return (
    <div className="container referral-container">
      <div className="banner-container d-flex">
        <div className="round-content"></div>
        <div className="content">
          <h1>Refer & Earn</h1>
           <p> {refData?.referreeBonus}% cashback in your wallet. <br/> your friend gets {refData?.referralBonus}% discount .</p>

          <img
            className="img-fluid"
            src={bannerbottom}
            alt="referral banner img 0"
          />
        </div>
        <div>
          <img
            src={bannersideimage}
            className="img-fluid"
            alt="referral banner img 1"
          />
        </div>
      </div>
      <div className="referral-details mt-5">
        <div className="row">
          <div className="col-md-5">
            <h2>How it works?</h2>

            <div className="step step1 mt-4">
              <div>
                <div className="circle ">
                  1
                </div>
              </div>
              <div>
                <div className="progress-title">Invite your friends.</div>
                <div className="caption">Just share your referral code or link.</div>
              </div>
            </div>
            <div className="step step2">
              <div>
                <div className="circle">2</div>
              </div>
              <div>
                <div className="progress-title">They hit the road.</div>
                <div className="caption">Ask them to use referral code <br/> on checkout to get {refData?.referralBonus}% discount.</div>
              </div>
            </div>
            <div className="step step3">
              <div>
                <div className="circle">3</div>
              </div>
              <div>
                <div className="progress-title">You make savings!</div>
                <div className="caption">After they subscribe, you’ll get <br/> {refData?.referreeBonus}%  cashback in your wallet 🎉. </div>

              </div>
            </div>
            <div className="step step4">
              <div>
                <div className="circle">4</div>
              </div>
              <div>

                <div className="progress-title">Get ₹{refData?.extraBonus} in your wallet.</div>
                <div className="caption">For every third referral, you’ll receive <br/> {refData?.extraBonus} INR in your wallet <br/> plus {refData?.referreeBonus}% of total purchase amount. </div>

              </div>
            </div>
          </div>
          <div className="col-md-7">

          <div className="row">
                <div className="col referral-data">
                  <div className="card mx-auto">
                    <div className="card-body">

                    <div className="copy-code">
                        <p>Your Referral Code : </p>
                        <div className="input-group mb-3">
                          <input 
                           type="text" 
                           className="form-control" 
                           value={refData ?refData.showReferralUi? refData.refCode :"Hidden": "Loading.."}
                          />
                        <CopyToClipboard
                          text={refData ?refData.showReferralUi? refData.refCode :"Hidden": "Loading.."}

                          onCopy={() => {
                            openSnackbar("Referral code copied successfully");
                            setCopied(true);
                          }}
                        >
                            <div className="input-group-append my-auto mx-auto">
                                <button className="btn " type="button">Copy</button>
                            </div>
                        </CopyToClipboard> 
                        </div>

                        {
                          !refData?.showReferralUi?
                          <p className="text-danger">Please subscribe to unlock Refer & Earn !</p>
                          :""
                        }
                       
                      </div>


                      <div className="social-share mt-4">
                        <SocialMediaButtons refData={refData?refData.showReferralUi?refData:null:"Loading..."} />

                      </div>

                    </div>
                  </div>
                </div>
              </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Referral;
